
const DISTANCE = 100;
const DURATION = 400;
const map = new WeakMap();
const ob = new IntersectionObserver((entries)=>{
  for(const entry of entries) {
    if(entry.isIntersecting) {
      const animation = map.get(entry.target)
      if(animation){
        animation.play()
        ob.unobserve(entry.target)
      }
    }
  }
})
function isBelowViewport(el){
  const rect = el.getBoundingClientRect();
  return rect.top - DISTANCE > window.innerHeight;
}
import Vue from 'vue'
Vue.directive('slidein', {
  bind(el){
    Vue.nextTick(() => {
      setTimeout(() => {
        if(!isBelowViewport(el)){
          return;
        }
        const animation = el.animate([
          {
            transform:`translateY(${DISTANCE}px)`,
            opacity:0.5,
          },
          {
            transform:`translateY(0)`,
            opacity:1,
          }
        ],{
          duration:DURATION,
          easing:'ease-in-out',
          fill:'forwards'
        })
        animation.pause()
        ob.observe(el)
        map.set(el,animation)
      },300)
    });
  },
  unbind(el){
    ob.unobserve(el)
  }
});